import { render, staticRenderFns } from "./BlockSoftConversion.vue?vue&type=template&id=2336a4d8&"
import script from "./BlockSoftConversion.vue?vue&type=script&lang=js&"
export * from "./BlockSoftConversion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports